import { Box, Button, Collapse, Grid, Paper, TextField } from '@material-ui/core';
import React from 'react';

import { CERTIFICATES_FILTERS } from '../../hooks/useCertificates';

/**
 * 
 * @param {import('@material-ui/core').TextFieldProps} props 
 * @returns 
 */
const DefaultInput = (props) => {
  return (
    <TextField
      key={props?.defaultValue}
      variant="outlined"
      fullWidth
      {...props}
    />
  )
}

export default function CertificatesFilters({ open, filters = {}, onSubmitFilters, onClearFilters }) {
  const handleSubmit = (e) => {
    e?.preventDefault();

    const formData = new FormData(e.target);
    const formValues = Object.fromEntries(formData);

    onSubmitFilters(formValues);
  }

  const handleClearFilters = () => {
    onClearFilters();
  }

  const hasFilters = Object.values(filters).length > 0;

  return (
    <Collapse in={open}>
      <Paper>
        <Box p={2} component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item container spacing={2}>
              <Grid item xs={6}>
                <DefaultInput
                  name={CERTIFICATES_FILTERS.USER}
                  label="Aluno"
                  defaultValue={filters[CERTIFICATES_FILTERS.USER]}
                />
              </Grid>
              <Grid item xs={6}>
                <DefaultInput
                  name={CERTIFICATES_FILTERS.COURSE}
                  label="Curso"
                  defaultValue={filters[CERTIFICATES_FILTERS.COURSE]}
                />
              </Grid>
            </Grid>
            <Grid item container spacing={2} justify="flex-end">
              <Grid item>
                {hasFilters && (
                  <Button type="button" variant="outlined" color="primary" onClick={handleClearFilters}>Limpar</Button>
                )}
              </Grid>
              <Grid item>
                <Button type="submit" variant="contained" color="primary">Filtrar</Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Box height="1rem" />
    </Collapse>
  )
}